import { Font } from "components/shopFeatures/wizard/constants"
import styled from "styled-components"
import { TypographyCenter } from "theme/shared"
import { FormSvgIcon } from "./FormWarningSvgIcon"

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const StyledSvgContainer = styled.div`
  margin-bottom: 10px;
`

export const StyledTitle = styled(TypographyCenter)`
  margin-bottom: 10px;
`

export const StyledSubTitle = styled(TypographyCenter)`
  font-family: ${Font.OENaPro};
  font-size: 18px;
  font-weight: 300;
  line-height: 27px;
  letter-spacing: 0em;
  max-width: 325px;
`

type FormErrorStateProps = {
  title?: string
  subtitle?: string
}

const FormErrorState = ({
  title = "משהו השתבש",
  subtitle = "נראה שמשהו השתבש ולא הצלחנו לרשום אותך. אנחנו נשוב אלייך מאוחר יותר.",
}: FormErrorStateProps) => {
  return (
    <StyledWrapper>
      <StyledSvgContainer>
        <FormSvgIcon />
      </StyledSvgContainer>
      <StyledTitle variant="h2">{title}</StyledTitle>
      <StyledSubTitle variant="body1">{subtitle}</StyledSubTitle>
    </StyledWrapper>
  )
}

export default FormErrorState
